import { render } from "./zibo.vue?vue&type=template&id=dde93f70"
import script from "./zibo.vue?vue&type=script&lang=js"
export * from "./zibo.vue?vue&type=script&lang=js"

import "./zibo.vue?vue&type=style&index=0&id=dde93f70&lang=css"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__